import React from 'react';
import cx from 'classnames';

export const ProcessingBar = ( {animated, color} ) => {
    const wrapperClassName = cx( 'h-1.5 block rounded-lg',
        {
            'shimmer-color': animated
        } );
    const progressClassName = cx( 'absolute top-0 h-1.5 w-full m-0 rounded-lg border-none',
        `bg-${color} opacity-90`,
        {
            'shimmer': animated
        } );
    return (
        <div className="fadeUp relative" data-testid="ProgressBar">
            <span className={wrapperClassName}>
                <hr className={progressClassName}/>
            </span>
        </div>
    )
}

const ProgressBar = ( {
                          progress,
                          animated = true,
                          color = 'blue',
                          backgroundColor = 'transparent',
                          className = ''
                      } ) =>
    <div role="progressbar" className={cx( `bg-${backgroundColor} w-full rounded-full`, className )}>
        <div style={{width: progress + '%'}}>
            <ProcessingBar animated={animated} color={color}/>
        </div>
    </div>;

export default ProgressBar;
